import React  from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig'

const PublicRoute = () => {
	const { token } = useSelector(state => state.auth)
	const location = useLocation()
	const searchParams = new URLSearchParams(location.search)
	const redirectParam = searchParams.get('redirect')

	return token
		? <Navigate to={redirectParam || AUTHENTICATED_ENTRY} replace />
		: <Outlet/>
}

export default PublicRoute